"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.unprefix = void 0;
var compact_1 = require("./compact");
var isVoid_1 = require("./isVoid");
var unprefix = function (prefix, obj) {
    if (!obj) {
        return undefined;
    }
    var unprefixObj = compact_1.compact(Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        if (key.startsWith(prefix + "_")) {
            return __assign(__assign({}, acc), (_b = {}, _b[key.replace(prefix + "_", '')] = value, _b));
        }
        return acc;
    }, {}));
    return isVoid_1.isVoid(unprefixObj) ? undefined : unprefixObj;
};
exports.unprefix = unprefix;
//# sourceMappingURL=unprefix.js.map